// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/img/CIUDAD_ENCANTALA_GALERIA_BACKGROUND.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Galeria-Container {
  margin-top: 225px;
  display: flex;
  min-height: 700px;
  justify-content: center;
  align-items: center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.Galeria-Container .imagenCarrusel {
  width: 98%;
  height: 100%;
  margin: 15px;
}
.Galeria-Container .containerImage {
  max-width: 96%;
  height: 475px;
  overflow: hidden;
}

@media screen and (max-width: 900px) and (min-width: 600px) {
  .Galeria-Container {
    margin-top: 700px;
  }
}
@media screen and (max-width: 600px) and (min-width: 100px) {
  .Galeria-Container {
    margin-top: 630px;
  }
  .Galeria-Container .containerImage {
    width: 225px;
    height: 260px;
    text-align: center;
    overflow: hidden;
  }
  .Galeria-Container .imagenCarrusel {
    width: 100%;
  }
  .Galeria-Container .gridgapSlider {
    grid-gap: 30px;
  }
  .Galeria-Container .slick-arrow {
    display: none !important;
  }
  .Galeria-Container .slick-prev {
    display: none !important;
  }
  .Galeria-Container .slick-slider .slick-dots li {
    margin: 0 15px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Sections/Galeria/Galeria.scss"],"names":[],"mappings":"AAEA;EACE,iBAAA;EACA,aAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,yDAAA;AADF;AAGE;EACE,UAAA;EACA,YAAA;EACA,YAAA;AADJ;AAIE;EACE,cAAA;EACA,aAAA;EACA,gBAAA;AAFJ;;AAMA;EACE;IACE,iBAAA;EAHF;AACF;AAMA;EACE;IACE,iBAAA;EAJF;EAME;IACE,YAAA;IACA,aAAA;IACA,kBAAA;IAEA,gBAAA;EALJ;EAQE;IACE,WAAA;EANJ;EASE;IACE,cAAA;EAPJ;EAUE;IACE,wBAAA;EARJ;EAWE;IACE,wBAAA;EATJ;EAcM;IACE,cAAA;EAZR;AACF","sourcesContent":["@import \"~/src/utils/scss/index.scss\";\n\n.Galeria-Container {\n  margin-top: 225px;\n  display: flex;\n  min-height: 700px;\n  justify-content: center;\n  align-items: center;\n  background-image: url($Galeria_Backgroud);\n\n  .imagenCarrusel {\n    width: 98%;\n    height: 100%;\n    margin: 15px;\n  }\n\n  .containerImage {\n    max-width: 96%;\n    height: 475px;\n    overflow: hidden;\n  }\n}\n\n@media screen and (max-width: 900px) and (min-width: 600px) {\n  .Galeria-Container {\n    margin-top: 700px;\n  }\n}\n\n@media screen and (max-width: 600px) and (min-width: 100px) {\n  .Galeria-Container {\n    margin-top: 630px;\n\n    .containerImage {\n      width: 225px;\n      height: 260px;\n      text-align: center;\n\n      overflow: hidden;\n    }\n\n    .imagenCarrusel {\n      width: 100%;\n    }\n\n    .gridgapSlider {\n      grid-gap: 30px;\n    }\n\n    .slick-arrow {\n      display: none !important;\n    }\n\n    .slick-prev {\n      display: none !important;\n    }\n\n    .slick-slider {\n      .slick-dots {\n        li {\n          margin: 0 15px;\n        }\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
